import angular from 'angular';
import { default as docDataService } from 'app/services/data/doc.data.service';
import directive from './folder.directive';
import controller from './folder.controller';

const library = require('@safe-systems/ss-ui-components');

const {
  alerts,
  loaderService,
} = library;

export default angular.module('app.components.global.downloadDocument.folder', [
  alerts,
  docDataService,
  loaderService
])
  .directive('folder', directive)
  .controller('FolderController', controller)
  .name;

console.log('app.components.global.downloadDocument.documentManagementDialog.folder created');
